var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3.7824C5.76116 3.7824 3.86601 5.27163 3.22888 7.32469H20.9976C20.9458 5.35255 20.0584 3.49432 18.5565 2.22758C18.2264 1.9492 17.7548 1.9237 17.3973 2.16491L15.8631 3.20008C15.3003 3.57978 14.6391 3.7824 13.9627 3.7824H7.99998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.84292H21V10.8671C21.5523 10.8671 22 11.3202 22 11.8792V20.9879C22 21.5469 21.5523 22 21 22H3C2.44772 22 2 21.5469 2 20.9879V11.8792C2 11.3202 2.44772 10.8671 3 10.8671V8.84292ZM7 13.9033C6.44772 13.9033 6 14.3565 6 14.9154V17.9517C6 18.5106 6.44771 18.9638 7 18.9638H17C17.5523 18.9638 18 18.5106 18 17.9517V14.9154C18 14.3565 17.5523 13.9033 17 13.9033H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCream);
export default __webpack_public_path__ + "static/media/cream.4b4d5ee9d76603e885a981189385157f.svg";
export { ForwardRef as ReactComponent };